import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { map, range } from 'lodash';

export function PickStar({ value = 1 }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 10 10"
			width="10"
			height="10"
			fill="none"
		>
			{/* Half Star  */}
			{value > 0 && value < 1 && (
				<>
					<path
						fill="#DDD"
						d="m5.264.386 1.008 2.561H8.84c.512 0 .78.61.433.987L7.42 5.946l.786 2.713a.588.588 0 0 1-.87.667L4.717 7.74 2.08 9.327a.588.588 0 0 1-.868-.667l.779-2.715L.158 3.93a.588.588 0 0 1 .435-.984H3.13L4.17.38a.588.588 0 0 1 1.093.006Z"
					/>
					<mask
						id="a"
						width="10"
						height="10"
						x="0"
						y="0"
						maskUnits="userSpaceOnUse"
					>
						<path
							fill="#fff"
							fillRule="evenodd"
							d="m5.264.386 1.008 2.561H8.84c.512 0 .78.61.433.987L7.42 5.946l.786 2.713a.588.588 0 0 1-.87.667L4.717 7.74 2.08 9.327a.588.588 0 0 1-.868-.667l.779-2.715L.158 3.93a.588.588 0 0 1 .435-.984H3.13L4.17.38a.588.588 0 0 1 1.093.006Z"
							clipRule="evenodd"
						/>
					</mask>
					<g mask="url(#a)">
						<path
							fill="#527284"
							d="M0 0h4.706v9.412H0z"
						/>
					</g>
				</>
			)}
			{/* Full Star  */}
			{value >= 1 && (
				<path
					fill="#527284"
					d="m5.256.386 1.007 2.565h2.564a.59.59 0 0 1 .432.988L7.411 5.953l.785 2.717a.588.588 0 0 1-.869.667L4.71 7.75 2.077 9.338a.588.588 0 0 1-.867-.667l.778-2.719-1.83-2.016a.59.59 0 0 1 .434-.985h2.532L4.166.38a.587.587 0 0 1 1.09.005Z"
				/>
			)}
			{/* Empty Star  */}
			{value <= 0 && (
				<path
					fill="#DDD"
					d="m5.256.386 1.007 2.565h2.564a.59.59 0 0 1 .432.988L7.411 5.953l.785 2.717a.588.588 0 0 1-.869.667L4.71 7.75 2.077 9.338a.588.588 0 0 1-.867-.667l.778-2.719-1.83-2.016a.59.59 0 0 1 .434-.985h2.532L4.166.38a.587.587 0 0 1 1.09.005Z"
				/>
			)}
		</svg>
	);
}

PickStar.propTypes = {
	value: PropTypes.number,
};

export function BlueStarRating({ className, rating, outOf }) {
	return (
		<div className={classnames('star-rating', className)}>
			{map(range(0, outOf), (starValue) => (
				<PickStar
					key={starValue}
					value={rating - starValue}
					bg
				/>
			))}
		</div>
	);
}

BlueStarRating.propTypes = {
	className: PropTypes.string,
	/** The rating to show */
	rating: PropTypes.number,
	/** What the rating is out of */
	outOf: PropTypes.number,
};

BlueStarRating.defaultProps = {
	rating: 0,
	outOf: 5,
};

export default BlueStarRating;
